import React, { useEffect, useState } from "react";
import { getFirestore, setWithExpiry, getWithExpiry } from "../../config/firebase";
import logoWhatsapp from "../../assets/logoWhatsapp.png";
import "./whatsapp.scss";
import WhatsAppModal from "./WhatsAppModal";
import useFirestoreUpdate from "../../config/useFirestoreData";
import { getWhatsAppUrl, getUtmParams, saveUtmParams } from "../../config/whatsappConfig";
import { sendPostRequest } from "../../config/desol";

const WhatsAppFlotante = () => {
  const [mostrarWhatsapp, setMostrarWhatsapp] = useState(false);
  const [whatsappIndividual, setWhatsappIndividual] = useState(null);

  // Procesar UTM parameters al cargar el componente
  useEffect(() => {
    saveUtmParams();
  }, []);

  useEffect(() => {
    const cargarDatosInformacion = async () => {
      // Intentar recuperar los datos de localStorage con expiración
      const datosLocales = getWithExpiry("hyundai-informacion");
      if (datosLocales) {
        // Buscar el documento "whatsapp" en los datos locales
        const whatsappDoc = datosLocales.find((doc) => doc.id === "whatsapp");
        if (whatsappDoc) {
          setWhatsappIndividual(whatsappDoc.url);
          setMostrarWhatsapp(whatsappDoc.mostrar);
        }
      } else {
        // Si no hay datos en localStorage, hacer la llamada a Firestore
        const db = getFirestore();
        const vehicles = db.collection("hyundai-informacion");
        try {
          const querySnapshot = await vehicles.get();
          const datosCompletos = querySnapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }));

          // Buscar el documento "whatsapp" en los datos de Firestore
          const whatsappDoc = datosCompletos.find((doc) => doc.id === "whatsapp");
          if (whatsappDoc) {
            setWhatsappIndividual(whatsappDoc.url);
            setMostrarWhatsapp(whatsappDoc.mostrar);
          }

          // Guardar los datos en localStorage con expiración
          setWithExpiry("hyundai-informacion", datosCompletos);
        } catch (error) {
          console.error("Error al obtener datos de Firestore: ", error);
        }
      }
    };
    cargarDatosInformacion();
  }, []);

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { updateData } = useFirestoreUpdate("consultas", "validaciones");

  // Función simplificada para obtener la URL correcta según el UTM source
  const getWhatsAppUrlFromConfig = () => {
    console.log("=== WhatsAppFlotante Debug ===");
    console.log("Current URL:", window.location.href);

    const utmParams = getUtmParams();
    console.log("UTM Params:", utmParams);

    // Si hay UTM parameters específicos, usar la configuración externa
    if (utmParams.utm_source) {
      const whatsappUrl = getWhatsAppUrl(utmParams);
      console.log("Generated WhatsApp URL from config:", whatsappUrl);
      return whatsappUrl;
    }

    // Si no hay UTM parameters específicos, usar el número original como fallback
    console.log("Using original WhatsApp URL:", whatsappIndividual);
    return whatsappIndividual || "https://api.whatsapp.com/send?phone=543516825130&text=Hola%20Montironi%20Hyundai!";
  };

  const handleModalSubmit = async (values) => {
    setLoading(true);
    try {
      // Guardar en Firestore
      await updateData(values);

      // Obtener parámetros UTM para el envío a Desol
      const utmParams = getUtmParams();
      const utm_source = utmParams.utm_source || sessionStorage.getItem("utm_source") || "";
      const utm_medium = utmParams.utm_medium || sessionStorage.getItem("utm_medium") || "";

      // Preparar datos para Desol
      const dataForDesol = {
        Apellido: values.nombre,
        Email: values.email,
        Telefono: values.celular,
        Canal: "WhatsApp",
        Motivo: `Consulta por WhatsApp - ${utm_source}`,
        OrigenLead: `${process.env.REACT_APP_LANDING} - ${utm_source}`,
        CommercialCampaign: utm_medium,
        Campaign: "C12_HYUNDAI_LANDINGS",
        Modelo_Pedido: "Consulta WhatsApp",
      };

      // Enviar a Desol
      try {
        await sendPostRequest(process.env.REACT_APP_DESOL_URL, dataForDesol);
        console.log("Datos enviados exitosamente a Desol");
      } catch (desolError) {
        console.error("Error al enviar a Desol:", desolError);
        // No bloqueamos el flujo si falla Desol, solo mostramos el error en consola
      }

      setOpen(false);
      // Usar la URL correcta según el UTM source
      const whatsappUrl = getWhatsAppUrlFromConfig();
      window.location.href = whatsappUrl;
    } catch (error) {
      console.error("Error al procesar el formulario:", error);
      alert("Ocurrió un error al guardar los datos. Intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  if (!mostrarWhatsapp) {
    return null;
  }

  return (
    <div className="whatsapp-container">
      <WhatsAppModal open={open} onClose={() => setOpen(false)} onSubmit={handleModalSubmit} loading={loading} />
      <button className="btn-whatsapp-flotante" onClick={() => setOpen(true)} disabled={loading}>
        <img src={logoWhatsapp} alt="whatsapp" />
      </button>
    </div>
  );
};
export default WhatsAppFlotante;

